import { dailyLottoState } from '@/types/store';

const state: dailyLottoState = {
    totalDaily: 0,
    draws: [],
    cartDaily: [],
    markets: [],
};

export default state;
